import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

// React Router v6 BrowserRouter listens to browser navigation events, not this
// legacy standalone history instance. Keep old AppHistory.push/replace callers
// working by notifying BrowserRouter after programmatic navigation.
const notifyBrowserRouter = () => {
  if (typeof window === 'undefined') return;

  if (typeof PopStateEvent === 'function') {
    window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
    return;
  }

  window.dispatchEvent(new Event('popstate'));
};

// history v5 treats a missing second argument as `null` and that overwrites
// `state` placed on a location object. Keep the history v4 call shape working:
// push({ pathname, state }) and push(path, state).
const splitLocationState = (to: any, state?: any): [any, any] => {
  if (state === undefined && to && typeof to === 'object' && Object.prototype.hasOwnProperty.call(to, 'state')) {
    const { state: locationState, ...location } = to;
    return [location, locationState];
  }
  return [to, state];
};

const originalPush = history.push.bind(history);
history.push = ((to: any, state?: any) => {
  const [nextTo, nextState] = splitLocationState(to, state);
  originalPush(nextTo, nextState);
  notifyBrowserRouter();
}) as typeof history.push;

const originalReplace = history.replace.bind(history);
history.replace = ((to: any, state?: any) => {
  const [nextTo, nextState] = splitLocationState(to, state);
  originalReplace(nextTo, nextState);
  notifyBrowserRouter();
}) as typeof history.replace;

export default history;
